import type { StyleProps } from "@mallardbay/lib-react-components"
import { useColors } from "@mallardbay/lib-react-components"
import React, { type PropsWithChildren } from "react"

import BookingSummaryHeader, {
    type BookingSummaryHeaderProps,
} from "~components/pages/book/booking-summary-header"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props extends BookingSummaryHeaderProps, PropsWithChildren {
    readonly keepLargeViewportStyling?: boolean
    readonly noPaddingOnMobile?: boolean
}

export default function BookingSummaryContainer({
    title,
    note,
    imageUrl,
    listingTitle,
    listingType,
    locationState,
    keepLargeViewportStyling = false,
    noPaddingOnMobile,
    shouldHideListingHeader,
    children,
}: Props) {
    const styles = useStyles({ keepLargeViewportStyling, noPaddingOnMobile })

    return (
        <Box style={styles.container}>
            <BookingSummaryHeader
                title={title}
                note={note}
                imageUrl={imageUrl}
                locationState={locationState}
                listingType={listingType}
                listingTitle={listingTitle}
                shouldHideListingHeader={shouldHideListingHeader}
            />
            {children}
        </Box>
    )
}

function useStyles({
    keepLargeViewportStyling,
    noPaddingOnMobile,
}: {
    keepLargeViewportStyling: boolean
    noPaddingOnMobile?: boolean
}) {
    const colors = useColors()

    const desktopBorderRadius = "lg"
    const desktopBoxShadow = "rgba(0, 0, 0, 0.08) 0px 1px 12px"
    const desktopBorder = `1px solid ${colors.borderColor}`
    const desktopPadding = 6

    const mobileBorderRadius = keepLargeViewportStyling
        ? desktopBorderRadius
        : "0"
    const mobileBoxShadow = keepLargeViewportStyling ? desktopBorder : "none"
    const mobileBorder = keepLargeViewportStyling ? desktopBorder : "none"
    const mobilePadding = keepLargeViewportStyling ? desktopPadding : 4

    const container: StyleProps = {
        padding: {
            base: noPaddingOnMobile ? 0 : mobilePadding,
            md: desktopPadding,
        },
        boxShadow: { base: mobileBoxShadow, md: desktopBoxShadow },
        border: { base: mobileBorder, md: desktopBorder },
        borderRadius: { base: mobileBorderRadius, md: desktopBorderRadius },
    }

    return { container }
}
